import React from "react";

const title = () => {
  return (
    <div>
      <h1>My Gallery</h1>
      <h3>You don't take a photograph, you make it</h3>
    </div>
  );
};

export default title;
